import React from 'react';

const Button = ({ children, onClick, type = 'primary', buttonType = 'button', className = '', disabled = false }) => {
  const baseClass = 'px-4 py-2 rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-offset-2';

  const getButtonClass = () => {
    switch (type) {
      case 'primary':
        return `${baseClass} bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500`;
      case 'secondary':
        return `${baseClass} bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-500`;
      case 'success':
        return `${baseClass} bg-green-600 text-white hover:bg-green-700 focus:ring-green-500`;
      case 'danger':
        return `${baseClass} bg-red-600 text-white hover:bg-red-700 focus:ring-red-500`;
      default:
        return `${baseClass} bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500`;
    }
  };

  return (
    <button
      type={buttonType === 'submit' ? 'submit' : 'button'}
      className={`${getButtonClass()} ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;